export enum DebtEmployeeStatus {
    Collected = 1,
    NotYetCollect = 2
}